import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=985e1042&scoped=true&"
import script from "./subject.vue?vue&type=script&lang=ts&"
export * from "./subject.vue?vue&type=script&lang=ts&"
import style0 from "./subject.vue?vue&type=style&index=0&id=985e1042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985e1042",
  null
  
)

export default component.exports